module.exports = __webpack_public_path__ + "img/ic_space.4a0bf31f.png";